import { TweenMax, Power4 } from 'gsap';

import Nav from './nav';

class NavMobile extends Nav {
  constructor() {
    super();

    this.dom.button = this.dom.nav.querySelector('.js-button');
    this.dom.wrapper = this.dom.nav.querySelectorAll('.js-wrapper');
    this.dom.items = this.dom.nav.querySelectorAll('.js-item');

    this.state.open = false;
    this.state.isInitialized = false;

    this.animation = {
      bgDuration: 0.2,
      itemsDuration: 0.6,
      itemsDelay: 0.05
    };
  }

  animateItems(dir) {
    TweenMax.staggerFromTo(
      this.dom.items,
      this.animation.itemsDuration,
      { y: (dir === 'in' ? -10 : 0), autoAlpha: (dir === 'in' ? 0 : 1) },
      { y: (dir === 'in' ? 0 : -10), autoAlpha: (dir === 'in' ? 1 : 0), ease: Power4.easeOut },
      (dir === 'in' ? this.animation.itemsDelay : -this.animation.itemsDelay)
    );
  }

  toggle = () => {
    if (this.state.isAnimating) return;

    this.state.isAnimating = true;

    this.dom.nav.classList.toggle('nav--open');

    const tween = TweenMax.fromTo(
      this.dom.wrapper,
      this.animation.bgDuration,
      { autoAlpha: 0 },
      { autoAlpha: 1 }
    );

    if (!this.state.open) {
      tween.play();
      this.animateItems('in');
    }

    if (this.state.open) {
      tween.reverse(0);
      this.animateItems('out');
    }

    this.state.open = !this.state.open;
    setTimeout(() => this.state.isAnimating = false, 1000);
  }

  resize = () => {
    this.resizeHandler();

    if (this.state.isMobile && !this.state.isInitialized) this.initNav();
    if (!this.state.isMobile && this.state.isInitialized) this.destroyNav();
  }

  initNav() {
    window.addEventListener('resize', this.resize, { passive: true });
    this.dom.button.addEventListener('click', this.toggle, { passive: true });
    [...this.dom.items].forEach((item) => item.addEventListener('click', this.toggle, { passive: true }));

    this.state.isInitialized = true;
  }

  destroyNav() {
    this.dom.button.removeEventListener('click', this.toggle);
    [...this.dom.items].forEach((item) => item.removeEventListener('click', this.toggle));

    this.state.isInitialized = false;
  }
}

export default NavMobile;
